"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollRail = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const context_2 = require("./context");
const useSyncStore_1 = require("../../hooks/useSyncStore");
const Thumb_1 = require("./Thumb");
const blockClass = (0, nano_theme_1.drule)({
    pos: 'absolute',
    top: 0,
    insetInlineEnd: 0,
    b: 0,
    trs: 'opacity .2s ease',
    z: 1,
});
const addCssLength = (base, inset) => {
    if (inset === undefined)
        return base || undefined;
    if (typeof inset === 'number')
        return base + inset;
    if (!base)
        return inset;
    return `calc(${base}px + ${inset})`;
};
const ScrollRail = ({ children = React.createElement(Thumb_1.Thumb, null), className, style, ...rest }) => {
    const state = (0, context_2.useScrollArea)();
    const styles = (0, context_1.useStyles)();
    const visible = (0, useSyncStore_1.useSyncStore)(state.visible$);
    const alwaysVisible = (0, useSyncStore_1.useSyncStore)(state.alwaysVisible$);
    const railWidth = (0, useSyncStore_1.useSyncStore)(state.railWidth$);
    const canScroll = (0, useSyncStore_1.useSyncStore)(state.canScroll$);
    const headerHeight = (0, useSyncStore_1.useSyncStore)(state.headerHeight$);
    const footerHeight = (0, useSyncStore_1.useSyncStore)(state.footerHeight$);
    const isVisible = alwaysVisible || visible;
    const { top, bottom, ...restStyle } = style ?? {};
    if (!canScroll && !alwaysVisible)
        return null;
    return (React.createElement("div", { ...rest, ref: state.setRail, className: blockClass({ bg: styles.g(0, 0.04), '&:hover': { bg: styles.g(0, 0.08) } }) + (className ? ' ' + className : ''), "data-state": isVisible ? 'visible' : 'hidden', style: {
            width: railWidth,
            top: addCssLength(headerHeight, top),
            bottom: addCssLength(footerHeight, bottom),
            opacity: isVisible ? 1 : 0,
            pointerEvents: isVisible ? 'auto' : 'none',
            ...restStyle,
        }, onPointerDown: state.onScrollbarPointerDown, onPointerMove: state.onScrollbarPointerMove, onPointerUp: state.onScrollbarPointerUp, onWheel: state.onScrollbarWheel, onPointerEnter: state.onScrollbarPointerEnter }, children));
};
exports.ScrollRail = ScrollRail;
